import type { FireAnalyticsEvent } from '../../types';

type DegradableDependency = 'search-config' | `search-3p-config` | 'outbound-auth-github' | 'search-combined-config';

type onDegradedDependencyArgs = {
	dependency: DegradableDependency;
	searchSessionId: string;
	reason: string;
	source: string;
};

// Fires an event when a dependency of search page fails or times out
// Note: should be fired at the request level, so the UX may not be affected due to e.g. caching
export const onDegradedDependency = ({
	dependency,
	searchSessionId,
	reason,
	source,
}: onDegradedDependencyArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'degradedDependency',
		actionSubject: 'searchPage',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				degradedDependency: dependency,
				reason,
				searchSessionId,
			},
		},
	};
};
